module.exports = __webpack_public_path__ + "static/img/3s-platform-img1.667ee24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img1.png
// module id = wufj
// module chunks = 0